import { render, staticRenderFns } from "./ReviewHrDocumentDialog.vue?vue&type=template&id=708b91a1&scoped=true&"
import script from "./ReviewHrDocumentDialog.vue?vue&type=script&lang=js&"
export * from "./ReviewHrDocumentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708b91a1",
  null
  
)

export default component.exports